import { ToastLib } from 'components/Organisms/ToastLib'
import { toast } from 'react-toastify'
import { useDebouncedCallback } from 'utils/hooks/useDebounceCallback'

export const useYoloToast = () => {
  const yToast = (toastObj) => {
    const { id, props, ...config } = toastObj
    toast(<ToastLib toastId={id} {...props} />, config)
  }
  const debouncedYToast = useDebouncedCallback(yToast, 100)
  const yToastDismiss = toast.dismiss
  return { yToast: debouncedYToast, yToastDismiss }
}
